import * as React from 'react'

import { CmsContainerPage, CmsHeadTags, CmsPageLayout } from '@grandvision/bloomreach'
import { Container } from '@grandvision/elements'
import { ErrorPage } from '@grandvision/layout'

import { defaultErrorProps } from '../components/error-props'
import { layoutProps } from '../components/layout-props'

type InitialProps = {
  statusCode: number
}

type Props = InitialProps & {}

const Error = ({ statusCode }: Props) => {
  const ErrorContent = (
    <React.Fragment>
      <CmsHeadTags title={defaultErrorProps.header} noIndex={true} noFollow={true} />
      <Container className="error-layout">
        <ErrorPage {...defaultErrorProps} />
      </Container>
    </React.Fragment>
  )

  // We only receive a pageModel on 200 and 404 responses
  if (statusCode === 404) {
    return (
      <CmsContainerPage>
        <CmsPageLayout {...layoutProps}>{ErrorContent}</CmsPageLayout>
      </CmsContainerPage>
    )
  }

  return ErrorContent
}

Error.getInitialProps = ({ res, err }): InitialProps => {
  const statusCode = res ? res.statusCode : err ? err.statusCode : 500
  return { statusCode }
}

export default Error
